module.exports = __webpack_public_path__ + "static/media/img3.886ff5e3.jpg";